import React, { useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const ImportarEscalafonPolicia = ({ onImportado }) => {
  const inputRef = useRef(null);

  const [archivo, setArchivo] = useState(null);
  const [arrastrando, setArrastrando] = useState(false);
  const [cargando, setCargando] = useState(false);

  const API_URL =
    "https://wwwa.isepsantafe.net.ar/expedientes/importar-escalafon-policia";

  const validarArchivo = (file) => {
    if (!file) return false;

    const extensionesPermitidas = [".xls", ".xlsx"];
    const nombre = file.name.toLowerCase();

    const valido = extensionesPermitidas.some((ext) => nombre.endsWith(ext));

    if (!valido) {
      Swal.fire({
        icon: "warning",
        title: "Archivo no válido",
        text: "Solo se permiten archivos Excel .xls o .xlsx",
      });
      return false;
    }

    setArchivo(file);
    return true;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setArrastrando(false);

    const file = e.dataTransfer.files?.[0];
    validarArchivo(file);
  };

  const handleSeleccionArchivo = (e) => {
    const file = e.target.files?.[0];
    validarArchivo(file);
  };

  const importarExcel = async () => {
    if (!archivo) {
      Swal.fire({
        icon: "info",
        title: "Seleccioná un archivo",
        text: "Primero tenés que arrastrar o elegir un Excel.",
      });
      return;
    }

    try {
      setCargando(true);

      const formData = new FormData();
      formData.append("archivo", archivo);

      const { data } = await axios.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Importación correcta",
        text: data?.msg || "El Excel fue importado correctamente.",
      });

      setArchivo(null);
      if (inputRef.current) inputRef.current.value = "";

      if (typeof onImportado === "function") {
        onImportado(data);
      }
    } catch (error) {
      console.error("Error importando escalafón:", error);

      Swal.fire({
        icon: "error",
        title: "Error al importar",
        text:
          error?.response?.data?.msg ||
          error?.response?.data?.error ||
          "No se pudo importar el archivo.",
      });
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={styles.contenedor}>
      <h2 style={styles.titulo}>Importar Escalafón Policía</h2>

      <div
        style={{
          ...styles.dropzone,
          ...(arrastrando ? styles.dropzoneActivo : {}),
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setArrastrando(true);
        }}
        onDragLeave={() => setArrastrando(false)}
        onDrop={handleDrop}
        onClick={() => inputRef.current?.click()}
      >
        <input
          ref={inputRef}
          type="file"
          accept=".xls,.xlsx"
          onChange={handleSeleccionArchivo}
          style={{ display: "none" }}
        />

        <div style={styles.icono}>📄</div>

        {archivo ? (
          <>
            <p style={styles.textoPrincipal}>Archivo seleccionado:</p>
            <p style={styles.archivo}>{archivo.name}</p>
          </>
        ) : (
          <>
            <p style={styles.textoPrincipal}>
              Arrastrá el Excel acá o hacé click para seleccionarlo
            </p>
            <p style={styles.textoSecundario}>
              Formatos permitidos: .xls / .xlsx
            </p>
          </>
        )}
      </div>

      <div style={styles.botones}>
        <button
          type="button"
          onClick={importarExcel}
          disabled={cargando || !archivo}
          style={{
            ...styles.botonImportar,
            ...(cargando || !archivo ? styles.botonDisabled : {}),
          }}
        >
          {cargando ? "Importando..." : "Importar Excel"}
        </button>

        {archivo && (
          <button
            type="button"
            disabled={cargando}
            onClick={() => {
              setArchivo(null);
              if (inputRef.current) inputRef.current.value = "";
            }}
            style={styles.botonLimpiar}
          >
            Quitar archivo
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  contenedor: {
    width: "100%",
    maxWidth: "650px",
    margin: "20px auto",
    padding: "24px",
    borderRadius: "18px",
    background: "#ffffff",
    boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
    fontFamily: "Arial, sans-serif",
  },
  titulo: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#1f2937",
  },
  dropzone: {
    border: "3px dashed #9ca3af",
    borderRadius: "18px",
    padding: "40px 20px",
    textAlign: "center",
    cursor: "pointer",
    background: "#f9fafb",
    transition: "0.2s",
  },
  dropzoneActivo: {
    borderColor: "#2563eb",
    background: "#eff6ff",
    transform: "scale(1.01)",
  },
  icono: {
    fontSize: "50px",
    marginBottom: "10px",
  },
  textoPrincipal: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#374151",
    margin: "8px 0",
  },
  textoSecundario: {
    fontSize: "14px",
    color: "#6b7280",
  },
  archivo: {
    fontSize: "15px",
    color: "#2563eb",
    fontWeight: "bold",
    wordBreak: "break-all",
  },
  botones: {
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    marginTop: "20px",
    flexWrap: "wrap",
  },
  botonImportar: {
    border: "none",
    borderRadius: "10px",
    padding: "12px 22px",
    background: "#2563eb",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
  botonDisabled: {
    background: "#9ca3af",
    cursor: "not-allowed",
  },
  botonLimpiar: {
    border: "none",
    borderRadius: "10px",
    padding: "12px 22px",
    background: "#ef4444",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
  },
};

export default ImportarEscalafonPolicia;